import { connect } from 'react-redux';
import { setExpandedRecipe } from '../../../../actions';
import SchemaValidationsEditor from './SchemaValidationsEditor';

const mapStateToProps = (state) => {
  const {
    recipeBuilder: { expandedRecipeIndex },
    schemaEditor: {
      toSchema: { flat: toFlat },
    },
  } = state;

  return {
    toFlat,
    expandedRecipeIndex,
  };
};

export default connect(mapStateToProps, { setExpandedRecipe })(SchemaValidationsEditor);
